import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  const clonedReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(clonedReq).pipe(
    catchError((err: HttpErrorResponse) => {
      // Token expirado/inválido: encerra a sessão e pede novo login
      if (err.status === 401) {
        authService.logout();
        localStorage.setItem('redirect_after_login', router.url);
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
